import Head from 'next/head';
import RefundPolicy from '@/components/refundpolicy/refundpolicy';
import { useEffect } from 'react';
import { getGuestLogDetailsApi } from '@/components/action/easycampus';



export default function RefundPolicyPage() {


  useEffect(() => {
    handleGestLogUserData();

  }, []);

  const handleGestLogUserData = async () => {
    try {
      let data = {
        pageName:"Refund Policy"
      }

      const res = await getGuestLogDetailsApi(data);
      return;
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
       <Head>
      <title>Refund Policy : Refund Policy</title>
      <meta property="og:type" content="website"/>
      <meta name="description" content={"Easycampus"}/>
     <meta property="og:title" content={"Refund Policy: Easycampus Refund Policy"}/>
      <meta name="description" content={"Refund Policy : Easycampus Refund Policy"}/>
      <meta name="keywords" content={"Easycampus"}/>
      <meta property="og:url" content={"www.easycampus.in"}/>
      <meta property="og:description" content={"Refund Policy : Easycampus Refund Policy"}/>
      <meta property="og:image" content={'https://ec-images.s3.ap-south-1.amazonaws.com/easycampus-logo-for-video.png'}/>
    </Head> 
      <main className="flex min-h-screen flex-col">
          <div className="w-full mx-auto">
             <RefundPolicy/>
          </div>
        </main>
    </>
  );
}
